import DiscoveryPortalPanel from "@/components/discovery/DiscoveryPortalPanel";

/**
 * FranchiseeDiscoveryPortalPanel
 *
 * Reuses the existing Sales-Pipeline DiscoveryPortalPanel for the
 * post-conversion context. The panel reads the Discovery Portal state
 * off the *original contact* (not the franchisee record) so nothing is
 * duplicated — a single source of truth per the V1 brief §2/§10.
 *
 * The parent controls the expandable-panel chrome; this component just
 * renders the reused inner card once the franchisee's
 * ``converted_from_contact_id`` is known.
 */
export default function FranchiseeDiscoveryPortalPanel({ franchisee }) {
  const contactId = franchisee?.converted_from_contact_id;
  if (!contactId) {
    return (
      <div
        className="text-sm text-stone-500 italic p-4"
        data-testid="discovery-portal-panel-no-contact"
      >
        No Discovery Portal linked — this franchisee was not created via
        Convert-to-Franchisee.
      </div>
    );
  }
  // The reused panel only needs the contact id — everything else is
  // fetched from the /admin/contacts/{id}/discovery-portal endpoint.
  return (
    <div data-testid="franchisee-discovery-portal-panel">
      <DiscoveryPortalPanel contact={{ id: contactId }} />
    </div>
  );
}
